/*!
* name ZJX  资源下载
* Copyright 2018-2019
*/
<template>
  <div>
    <publicBanner :imgList="imgList"></publicBanner>
    <div class="resourcedetails_content">
      <div class="resourcedetails_tab_title">
        <span>
          乐画 >
          <a @click="goResourcedownloading">资源下载</a>
        </span>
      </div>
      <div class="resourcedetails_content_box">
        <div class="resourcedetails_content_title">
          <!--          <div></div>-->
          <div class="title">
            <span class="_title">{{resources.title}}</span>
            <p>
              <span>{{resources.authorName === '乐画网' ? resources.authorName : resources.authorName + '老师' }}</span>
              <span>分享于{{resources.shared_at}}</span>
              <span>资源ID:{{resources.rid}}</span>
            </p>
          </div>
          <div class="share">
            <span class="resourcedetails_border" @click="doYouLike(resources.is_thumb_up)">
              <img v-if="resources.is_thumb_up == true" src="../../assets/images/dianzan.png" alt>
              <img v-else src="../../assets/images/zan.png" alt>
            </span>
            &nbsp;
            <span class="sharingcenter_border_text">{{resources.thumb_up_num}}</span>
            <span class="sharingcenter_border_text_xz">{{resources.download_num}}次</span>
            <img class="sharingcenter_border_xz" @click="elasticFrame" src="../../assets/images/download.png" alt>
          </div>
        </div>
        <div class="resourcedetails_content_img">
          <img :src="resources.avatar" alt>
        </div>
        <div class="resourcedetails_content_nei">
          <p class="p1">教学要求：</p>
          <p>{{resources.content}}</p>
          <br>
          <br>
        </div>
      </div>
    </div>
    <el-dialog title="下载" :visible.sync="dialogTableVisible">
      <ul class="attachmentsList">
        <li v-for="(item,index) in resources.attachmentsList" :key="index">
          <a :href="item.download_url + '&token=' + token.Authorization" download="91374">
            {{item.file_name}}
          </a>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex' // 引入全局vuex
import publicBanner from '@/components/publicBanner' // 引入尾部
import cacheUtils from '@/common/cacheUtils' // 调用缓存
import apiInterface from '@/api/index' // 接口
export default {
  data () {
    return {
      imgList: [
        {
          id: 1,
          src:
            "http://lehuawang.dzhhb.com/imgs/banner0011.png"
        },
        {
          id: 2,
          src:
            "http://lehuawang.dzhhb.com/imgs/banner0021.png"
        },
        {
          id: 3,
          src:
            "http://lehuawang.dzhhb.com/imgs/banner0031.png"
        }
      ], // 存放img列表的数组
      resources: { // 详情页需要的数据
        rid: '',
        title: '',
        content: '',
        thumb_up_num: 0,
        download_num: 0,
        shared_at: '',
        avatar: {},
        authornName: '',
        operator: '',
        operatorName: '',
        is_thumb_up: '',
        attachmentsList: [],
        authorName: ''
      },
      id: '',
      dialogTableVisible: false,
      source: '',
      token: { Authorization: cacheUtils.cookie.getObject('Token') },
    }
  },
  computed: {},
  mounted () {},
  components: {
    publicBanner
  },
  created () {
    this.id = this.$route.query.id
    this.source = this.$route.query.source
    this.getResourcedetails(this.$route.query.id)
  },
  methods: {
    // 点赞方法
    doYouLike (status) {
      if (cacheUtils.cookie.getObject('Token') == null) {
        this.$router.push({ path: '/' })
        return
      } else {
        if (status == true) {
          this.clearThumbsUp(this.$route.query.id)
        } else {
          this.thumbsUp(this.$route.query.id)
        }
      }
    },
    // 资源点在取消接口
    async clearThumbsUp (item) {
      try {
        let pdata = await this.$xhr.post(
          apiInterface.thumbUp + item + '/thumb-up-remove'
        )
        this.resources.thumb_up_num -= 1
        this.resources.is_thumb_up = false
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 资源点赞接口
    async thumbsUp (item) {
      try {
        let pdata = await this.$xhr.post(
          apiInterface.thumbUp + item + '/thumb-up'
        )
        this.resources.thumb_up_num += 1
        this.resources.is_thumb_up = true
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 点赞
    goResourcedownloading () {
      if (this.source == 'jxzy') {
        this.$router.push({
          path: '/personalcenter'
        })
      } else {
        this.$router.push({
          path: '/resourcedownloading'
        })
      }
    },
    // 获取详情页列表
    async getResourcedetails (id) {
      try {
        let pdata = await this.$xhr.get(apiInterface.resourcesDtels + id, {
          params: {}
        })
        this.resources.rid = pdata.data.rid
        this.resources.title = pdata.data.title
        this.resources.content = pdata.data.content
        this.resources.thumb_up_num = pdata.data.thumb_up_num
        this.resources.download_num = pdata.data.download_num
        this.resources.avatar = pdata.data.avatar
        this.resources.authorName = pdata.data.author.name ? pdata.data.author.name : pdata.data.author ? pdata.data.author : '乐画网'
        this.resources.shared_at = pdata.data.shared_at
        this.resources.is_thumb_up = pdata.data.is_thumb_up
        this.resources.attachmentsList = pdata.data.attachments
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 下载附件
    async downAttachments (item) {
      try {
        let pdata = await this.$xhr.get(apiInterface.thumbUp + item.id + '/download', {
          params: {}
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 下载弹框
    elasticFrame () {
      this.dialogTableVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.resourcedetails_content {
  box-sizing: border-box;
  padding-top: 480px;
  // padding-left: 20px;
  // padding-right: 20px;
  .resourcedetails_tab_title {
    box-sizing: border-box;
    line-height: 15px;
    padding-left: 20px;
  }

  .resourcedetails_content_box {
    /*overflow: hidden;*/

    .resourcedetails_content_title {
      display: flex;
      justify-content: center;
      align-items: center;

      .title {
        width: 56%;
        margin: 0 auto;
        padding-top: 26px;
        box-sizing: border-box;

        ._title {
          display: block;
          text-align: center;
          font-size: 23px;
          font-weight: 600;
          word-break: break-all;
        }

        p {
          font: 12px/30px Microsoft YaHei;
          color: #666;
          text-align: center;

          span {
            margin-right: 4px;
          }
        }
      }

      .share {
        width: 20%;
        height: 100px;
        box-sizing: border-box;
        padding-top: 20px;
        padding-left: 33px;
        position: absolute;
        right: 50px;
      }

      /*div:nth-child(1) {*/
      /*  !*width: 302px;*!*/
      /*  width: 60%;*/
      /*  !*width: 20%;*!*/
      /*  !*height: 100px;*!*/
      /*  !*float: left;*!*/
      /*  line-height: 1.1;*/
      /*  box-sizing: border-box;*/
      /*  padding-top: 26px;*/
      /*}*/

      /*div:nth-child(2) {*/
      /*  !*width: 400px;*!*/
      /*  width: 60%;*/
      /*  float: left;*/
      /*  line-height: 1.1;*/
      /*  box-sizing: border-box;*/
      /*  padding-top: 26px;*/

      /*  p:nth-child(1) {*/
      /*    text-align: center;*/
      /*    font-size: 23px;*/
      /*    font-weight: 600;*/
      /*  }*/

      /*  p:nth-child(2) {*/
      /*    margin-top: 10px;*/
      /*    text-align: center;*/
      /*    font-size: 13px;*/

      /*    span:nth-child(1) {*/
      /*    }*/

      /*    span:nth-child(2) {*/
      /*      margin-left: 5px;*/
      /*      color: #aeaeae;*/
      /*    }*/

      /*    span:nth-child(3) {*/
      /*      margin-left: 15px;*/
      /*      color: #767676;*/
      /*    }*/
      /*  }*/
      /*}*/

      /*div:nth-child(3) {*/
      /*  width: 20%;*/
      /*  !*width: 275px;*!*/
      /*  height: 100px;*/
      /*  float: left;*/
      /*  box-sizing: border-box;*/
      /*  padding-top: 20px;*/
      /*  padding-left: 33px;*/
      /*  position: absolute;*/
      /*  right: 50px;*/
      /*}*/
    }

    .resourcedetails_content_img {
      /*height: 360px;*/

      img {
        width: 100%;
        /*height: 360px;*/
      }
    }

    .resourcedetails_content_nei {
      overflow: hidden;
      box-sizing: border-box;
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 30px;

      p {
        font-size: 16px;
      }

      .p1 {
        font-weight: 600;
        padding-bottom: 10px;
      }
    }
  }
}

.resourcedetails_border {
  display: inline-block;
  width: 47px;
  height: 38px;
  border: 1px solid #fea200;
  border-radius: 4px;
  float: left;
  text-align: center;
  line-height: 50px;
  margin-top: 19px;
  cursor: pointer;

  img {
    width: 22px;
    height: 22px;
    display: inline-block;
  }
}

.sharingcenter_border_text {
  font-size: 18px;
  margin-left: 5px;
  float: left;
  margin-top: 25px;
  margin-left: 10px;
}

.sharingcenter_border_xz {
  display: inline-block;
  width: 47px;
  height: 38px;
  background: #15c1e4;
  border-radius: 4px;
  float: right;
  margin-top: 19px;
  cursor: pointer;
}

.sharingcenter_border_text_xz {
  font-size: 18px;
  margin-left: 5px;
  float: right;
  margin-top: 25px;
}

.resourcedetails_content_boder {
  height: 143px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;

  .resourcedetails_di {
    height: 143px;
    box-sizing: border-box;
    border-top: 1px solid #f0f0f0;
    padding-top: 20px;
    font-size: 13px;

    div {
      width: 200px;
      overflow: hidden;
      float: right;
      cursor: pointer;

      img {
        float: right;
        width: 19px;
        height: 18px;
        margin-right: 5px;
        margin-top: 1px;
      }

      span {
        float: right;
      }
    }
  }
}

.attachmentsList {
  li {
    margin-bottom: 4px;
    cursor: pointer;

    a {

      color: -webkit-link;
      text-decoration: underline;
    }
  }
}
</style>

